import { type NonEmptyArray, positiveModulo } from '@ipfabric/utils';

export const getFromCyclicArray: {
  <T>(a: NonEmptyArray<T>, index: number): T;
  <T>(a: T[], index: number): T | undefined;
} = <T,>(a: T[], index: number): T | undefined =>
  a[positiveModulo(index, a.length)];
